import { CustomTable } from '@/components/Table';
import { Button, InputText } from '@/components';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventMachineSaleProductReport } from '@/model/EventMachineSaleProductReport';
import React, { Fragment } from 'react';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { ReportDropdownHeader } from '../../ReportDropdownHeader';

interface StateProps {
  machines: EventMachineSaleProductReport[];
  serialNumber: string;
  productName: string;
  onChangeSerialNumber: (value: string) => void;
  onChangeProductName: (value: string) => void;
  onFilter: () => void;
  onClearFilter: () => void;
}

export const SaleProductMachineContent: React.FC<StateProps> = ({
  machines,
  serialNumber,
  productName,
  onChangeSerialNumber,
  onChangeProductName,
  onFilter,
  onClearFilter,
}): JSX.Element => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      onFilter();
    }
  };

  return (
    <Fragment>
      {/* Container de Filtros com Flexbox e Botões alinhados à direita na linha abaixo */}
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          padding: '20px 24px',
          marginBottom: '24px',
          border: '1px solid #e9ecef',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
        }}
      >
        <h6
          style={{
            fontSize: '14px',
            fontWeight: 600,
            color: '#495057',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginBottom: '16px',
          }}
        >
          Filtros de Pesquisa
        </h6>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
            <div style={{ flex: '1 1 250px' }}>
              <InputText
                name="filterSerialNumber"
                label="Filtrar por Serial da Máquina"
                placeholder="Digite o serial da máquina"
                value={serialNumber}
                onChange={e => onChangeSerialNumber(e.target.value)}
                keyDow={handleKeyDown}
              />
            </div>
            <div style={{ flex: '1 1 250px' }}>
              <InputText
                name="filterProductName"
                label="Filtrar por Produto"
                placeholder="Digite o nome do produto"
                value={productName}
                onChange={e => onChangeProductName(e.target.value)}
                keyDow={handleKeyDown}
              />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <Button title="Pesquisar" theme="blue" onClick={onFilter} />
            <Button title="Limpar" theme="red" onClick={onClearFilter} />
          </div>
        </div>
      </div>

      {machines.map(data => (
        <div key={data.id} className="mb-3">
          <SuperCollapse
            title={
              <ReportDropdownHeader
                title={`POS: ${data.serialNumber}`}
                summary={data.summary}
                payments={data.payments}
              />
            }
            content={
              <div className="p-3 bg-white rounded">
                {data.categories.map(category => (
                  <div key={category.id} className="mb-4">
                    <h6 className="font-weight-bold mb-2 text-secondary">{category.name}</h6>
                    <CustomTable
                      theme="secondaryWithoutBorder"
                      numberRowsPerPage={0}
                      progressPending={false}
                      columns={[
                        {
                          name: 'Produto',
                          selector: row => row.productName,
                        },
                        {
                          name: 'Vendidos',
                          selector: row => row.productSold,
                        },
                        {
                          name: 'Valor',
                          selector: row => row.unitValue,
                        },
                        {
                          name: 'Venda',
                          selector: row => row.totalSaleValue,
                        },
                        {
                          name: 'Comissão',
                          selector: row => row.totalCommission,
                        },
                        {
                          name: 'Venda + Comissão',
                          selector: row => row.totalSaleWithCommission,
                        },
                      ]}
                      data={
                        category.products.map(product => ({
                          productName: product.name,
                          productSold: product.amountSold,
                          unitValue: toCurrency(product.unitValue),
                          totalSaleValue: toCurrency(product.totalSaleValue),
                          totalCommission: toCurrency(product.totalCommission),
                          totalSaleWithCommission: toCurrency(product.totalSaleWithCommission),
                        })) || []
                      }
                    />
                  </div>
                ))}
              </div>
            }
          />
        </div>
      ))}
    </Fragment>
  );
};
